import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { AddSectionOneEntryPayload } from "../add-section-one-entry";
import { useUpdateStatusToNewEntry } from "../mutate-hooks/use-update-status-to-new-entry.ts";

export const useUpdateStatusToNewEntryModal = ({
  search,
  sectionOneId,
}: {
  search: string;
  sectionOneId: string;
}) => {
  const { mutate: updateStatus } = useUpdateStatusToNewEntry({
    sectionOneId,
    search,
  });
  const queryClient = useQueryClient();

  const handleUpdate = ({
    sectionOneListId,
    itemNoVersionId,
    ...body
  }: AddSectionOneEntryPayload & {
    sectionOneListId: string;
    itemNoVersionId: string;
  }) => {
    updateStatus(
      {
        params: {
          path: {
            sectionOneListId,
            itemNoVersionId,
          },
        },
        // @ts-expect-error body не совпадает с openapi типами мутации
        body,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(
            journalsQueries.getSection1({
              sectionOneId: sectionOneListId,
              search,
            }),
          );
          notification.success({
            message: NOTIFICATION_MESSAGES.ENTRY_RETURNED_TO_NEW_ALT, // "Запись возвращена в статус 'Новый'"
          });
        },
        onSettled: () => {
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId: sectionOneListId,
              search,
            }).queryKey,
          });
        },
      },
    );
  };

  return { handleUpdate };
};
